import { AfterContentChecked, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { FooterService } from '../../../shared/services/footer.service';
import { CommonModule } from '@angular/common';
import { Column, Footer, requestPayload } from '../../../shared/models/model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements AfterContentChecked, OnDestroy {
  footerData: Footer | undefined;
  firstColumn!: Column;
  secondColumn!: Column;
  thirdColumn!: any;
  callToActionColumn!: Column;
  socialLinks!: any[];
  complianceId: string = '';
  disclosureText: string = '';
  footerDataSubscription: Subscription = new Subscription();

  constructor(
    private _footerService: FooterService,
    private _sanitizer: DomSanitizer,
    private _router: Router,
    public _cd: ChangeDetectorRef,
  ) {
    this.getFooter();
  }

  // Get footer data
  ngAfterContentChecked(): void {
    this.complianceId = this._footerService.getComplianceId();
    this.disclosureText = this._footerService.getDisclosureText();
    this._cd.detectChanges();
  }

  getFooter() {
    const payLoad: requestPayload = {
      requestingSystem: 'FinPro',
    };
    this.footerDataSubscription = this._footerService?.getFooterData(payLoad)?.subscribe((data: Footer) => {
      this.footerData = data;
      this.firstColumn = this.footerData.firstColumn;
      this.secondColumn = this.footerData.secondColumn;
      this.thirdColumn = this.footerData.thirdColumn.links.filter((d) => d.text !== 'Blog' && d.text !== 'LinkedIn');
      this.callToActionColumn = this.footerData.callToActionButton;
      this.socialLinks = this.footerData.thirdColumn.links.filter((d) => d.text === 'Blog' || d.text === 'LinkedIn');
      this.socialLinks.forEach((_element) => {
        switch (_element.text) {
          case 'Blog':
            _element.imgUrl = '../../../../assets/images/Blog Icon Black.png';
            break;
          case 'LinkedIn':
            _element.imgUrl = '../../../../assets/images/Icon_LinkedIn_Black.png';
            break;
          default:
            break;
        }
      });
      this._footerService.setDisclosureText(this.footerData.disclosureText);
      this._footerService.defaultDisclosureText = this.footerData.disclosureText;
      if (this._router.url.includes('/advisor/secure-file-upload')) {
        this._footerService.setComplianceID(this.footerData.fileUploadComplianceId);
      } else {
        this._footerService.setComplianceID(this.footerData.complianceId);
      }
      this._footerService.defaultComplianceId = this.footerData.complianceId;
    });
  }

  contentSanitizedHtml(content: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(content);
  }
  ngOnDestroy(): void {
    this.footerDataSubscription.unsubscribe();
  }
}
